import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const trigger = style([
  typography.labelSm,
  {
    display: 'inline-flex',
    alignItems: 'center',
    gap: space.s6,
    height: 32,
    padding: `0 ${space.s10}px`,
    borderRadius: borderRadius.r8,
    border: 'none',
    cursor: 'pointer',
    color: themeVars.controls.foreground.default,
    backgroundColor: themeVars.controls.background.default,
    outline: `1px solid ${themeVars.controls.border.default}`,
    outlineOffset: -1,
    transition:
      'background-color 0.15s ease, color 0.15s ease, outline-color 0.15s ease',
    whiteSpace: 'nowrap',

    ':hover': {
      color: themeVars.controls.foreground.input,
      outlineColor: themeVars.controls.border.hover,
    },

    ':focus-visible': {
      outline: `2px solid ${themeVars.controls.border.active}`,
      outlineOffset: -1,
    },

    selectors: {
      '&[aria-expanded="true"]': {
        color: themeVars.controls.foreground.input,
        outlineColor: themeVars.controls.border.active,
      },

      '&[data-active="true"]': {
        color: themeVars.controls.foreground.input,
        outlineColor: themeVars.color.border.brand,
      },
    },
  },
]);

export const triggerIcon = style({
  width: 14,
  height: 14,
  flexShrink: 0,
});

export const clearButton = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  height: 16,
  padding: 0,
  marginLeft: space.s2,
  border: 'none',
  borderRadius: borderRadius.r32,
  cursor: 'pointer',
  color: themeVars.container.foreground.secondary,
  backgroundColor: 'transparent',

  ':hover': {
    color: themeVars.container.foreground.primary,
    backgroundColor: themeVars.container.primary.background.hover,
  },
});

export const clearIcon = style({
  width: 12,
  height: 12,
});

export const popover = style({
  width: 280,
  padding: space.s12,
  display: 'flex',
  flexDirection: 'column',
  gap: space.s10,
});

export const field = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const fieldLabel = style([
  typography.labelSm,
  {
    color: themeVars.container.foreground.secondary,
    letterSpacing: '0.02em',
  },
]);

export const dateInput = style([
  typography.labelMd,
  {
    width: '100%',
    height: 32,
    padding: `0 ${space.s8}px`,
    borderRadius: borderRadius.r8,
    border: 'none',
    outline: `1px solid ${themeVars.controls.border.default}`,
    outlineOffset: -1,
    backgroundColor: themeVars.controls.background.default,
    color: themeVars.controls.foreground.input,
    colorScheme: 'dark light',

    ':hover': {
      outlineColor: themeVars.controls.border.hover,
    },

    ':focus': {
      outline: `1px solid ${themeVars.controls.border.active}`,
      outlineOffset: -1,
    },
  },
]);

export const footer = style({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: space.s2,
});

export const footerButton = style([
  typography.labelSm,
  {
    border: 'none',
    background: 'transparent',
    color: themeVars.container.foreground.secondary,
    cursor: 'pointer',
    padding: `${space.s4}px ${space.s6}px`,
    borderRadius: borderRadius.r4,

    ':hover': {
      color: themeVars.container.foreground.primary,
      backgroundColor: themeVars.container.primary.background.hover,
    },
  },
]);
